import React from 'react';
import {Flex, SVGButton} from '/app/src/component';

class BackBtn extends React.Component {
    render() {
        const {text, onClick} = this.props
        const btnStyle = {
            bg: 'LightGray2',
            height: '40px',
            color: 'MediumGray5',
            margin: '0px 0px 10px 20px'
        }
        return (
            <Flex>
                <SVGButton
                    {...btnStyle}
                    onClick={onClick}
                    text={text}
                    src='/images/Return.svg'/>
            </Flex>
        )
    }
}

export default BackBtn;



// WEBPACK FOOTER //
// ./src/component/Modal/PaymentModal/BackBtn.js